const formTools = {
    reloadPage: function (timeout = 2000) {
        setTimeout(function () {
            location.reload();
        }, timeout)
    },

    requestRegister: function () {
        window.location.href = '/' + lang + '/cabinet';
    },

    requestHomeClub: function (href) {
        window.location.href = href;
    },

    loaderForm: function (form, status, mini = '') {
        const parent = form.closest('div');
        if (status === 'start') {
            form.hide();
            parent.append(`<div class="loader_form js__loader_form ${mini}"><span class="loader ${mini}"></span></div>`);
        } else {
            form.show();
            parent.find('.js__loader_form').remove();
            this.toggleButton('unDisabled', form);
        }
    },

    serverErrorHandler: function(form, text) {
        let parent = form.closest('div');
        this.loaderForm(form, 'stop')
        form.hide()
        parent.append(`<div class="loader_form js_error_hanlder_form"><span class="error">${text ?? translations.server_error}</span></div>`)
        setTimeout(function() {
            window.location.reload()
        }, 3000)
    },

    isValidEmail: function (email) {
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return pattern.test(email);
    },

    isNotClubEmail: function (email, requestName) {
        const patternСlub = /@ralphlauren\.com$/i;
        return requestName === 'subscribe_modal' ? patternСlub.test(email) : false
    },

    isValidPhone: function (phone) {
        const phonePattern = /^[\d()+\-]{7,}/;
        return phonePattern.test(phone)
    },

    errorRequest: function (form, errorName, text = '') {
        const requestError = form.find(`.js__error_request[data-error=${errorName}]`);
        const wrapper = requestError.closest('label');

        requestError.slideDown('slow');
        wrapper.addClass('error-input');

        if (errorName == 'error_limit') {
            requestError.empty().append(text)
        }
    },

    clearForm: function (form) {
        form.find('input[type="text"], textarea').val('');
        $('.js__list_file').empty();
    },

    toggleButton: function (toggle, form = '') {
        const elements = form == '' ? $('.js__login_system') : form.find('.js__send_btn');

        if (toggle == 'disabled') {
            elements.addClass('disabled').prop('disabled', true);
        } else if (toggle == 'unDisabled') {
            elements.removeClass('disabled').prop('disabled', false);
            $('.js__login_system').removeClass('disabled').prop('disabled', false);
        }
    },

    lockSystem: function (btn = '') {
        btn.closest('.js__lock_system').addClass('error_system');
        $('.js__login_system').removeClass('disabled').prop('disabled', false);
    },

    showError: function (wrapper, selector) {
        wrapper.addClass('error_input');
        wrapper.find(selector).slideDown('slow');
    },

    clearErrors: function (wrapper) {
        wrapper.removeClass('error_input');
        wrapper.find('.error_required').hide();
    },

    clearAllErrors: function () {
        $('.input_wrapper').removeClass('error_input');
        $('.error_required').hide();
    },

    sortRequestForm: function (name, objectData, form = '') {
        const additionalSettings = {
            "thankYouModal": false,
            "form": form,
        };

        const sendObject = {
            'subj': false,
            'data': objectData,
        }

        switch (name) {
            case 'designRequests':
                sendObject.subj = 'design_requests';
                this.postSend(sendObject, additionalSettings);
                break;

            case 'subscribe':
                sendObject.subj = 'subscribe';
                this.postSend(sendObject, additionalSettings);
                break;

            case 'autorization':
                sendObject.subj = 'autorization';
                this.autorization(sendObject, additionalSettings);
                break;

            case 'subscribe_modal':
                sendObject.subj = 'subscribe_modal';
                this.subscribe(sendObject, additionalSettings);
                break;

            case 'registration':
                sendObject.subj = 'registration';
                this.registration(sendObject, additionalSettings);
                break;

            case 'pass_restore':
                sendObject.subj = 'pass_restore';
                this.passRestore(sendObject, additionalSettings);
                break;

            case 'edit_user_info':
                sendObject.subj = 'edit_user_info';
                this.editUserInfo(sendObject, additionalSettings);
                break;

            case 'edit_user_password':
                sendObject.subj = 'edit_user_password';
                this.editUserPassword(sendObject, additionalSettings);
                break;

            case 'paypal_payment':
                sendObject.subj = 'paypal_payment';
                this.paypal(sendObject, additionalSettings);
                break;

            case 'feedback':
                sendObject.subj = 'feedback';
                this.postSend(sendObject, additionalSettings);
                break;

            case 'product_enquiry':
                sendObject.subj = 'product_enquiry';
                this.postSend(sendObject, additionalSettings);
                break;

            case 'usePromoCode':
                this.usePromoCode(objectData, additionalSettings);
                break;
        }

    },

    usePromoCode: function (objectData, additionalSettings) {
        $.post(requests.usePromoCode, {
            'data': objectData,
            'subj': additionalSettings['subj'],
        }, function (data) {
            if (data.status) {
                formTools.loaderForm(additionalSettings['form'], 'stop');
            }

            if (data.status == 'success') {
                formTools.reloadPage(0);
            }

            if (data.status == 'error' || data.status == 'use_promo_code' || data.status == 'error_limit') {
                formTools.errorRequest(additionalSettings['form'], data.status, data.text);
            }
        });
    },

    postSend: function (sendObject, additionalSettings) {
        $.post(requests.postSend, sendObject, function (data) {
            if (data.status == 'success') {
                formTools.clearForm(additionalSettings['form']);
                formTools.loaderForm(additionalSettings['form'], 'stop');

                if (sendObject.subj == 'subscribe') {
                    $('.js_footer__content_subscribe').addClass('active')

                    setTimeout(function () {
                        $('.js_footer__content_subscribe').removeClass('active')
                    }, 10000)
                }
            }
        });
    },

    autorization: function (sendObject, additionalSettings) {
        $.post(requests.autorization, sendObject, function (data) {
            if (data.status == 'error_password' || data.status == 'error_login') {
                formTools.errorRequest(additionalSettings['form'], data.status);
                formTools.loaderForm(additionalSettings['form'], 'stop');
            }

            if (data.status == 'user_banned') {
                // Забаненный юзер
            }

            if (data.status == 'is_not_subscribe') {
                formTools.loaderForm(additionalSettings['form'], 'stop');
                $('.js_club-modal').removeClass('active')
                $('.js_club-modal[data-modal=subscribe]').addClass('active')
                $('.js_club-modal[data-modal=subscribe]').attr('data-reload', true)
            }

            if (data.status == 'success') {
                if (data.href) {
                    formTools.requestHomeClub(data.href);
                } else {
                    formTools.requestRegister();
                }
            }
        });
    },

    subscribe: function (sendObject, additionalSettings) {
        $.post(requests.subscribe, sendObject, function (data) {
            if (data.status == 'not_fount_user') {
            }

            if (data.status == 'error_subscribe') {
                formTools.serverErrorHandler(additionalSettings['form'])
            }

            if (data.status == 'success') {
                formTools.requestHomeClub(data.href);
            }
        })
        .fail(function() {
            formTools.serverErrorHandler(additionalSettings['form'])
        });
    },

    registration: function (sendObject, additionalSettings) {
        $.post(requests.registration, sendObject, function (data) {
            if (data.status == 'error_repeat' || data.status == 'error_login_busy') {
                formTools.loaderForm(additionalSettings['form'], 'stop');
                formTools.errorRequest(additionalSettings['form'], data.status);
            }

            if (data.status == 'error_subscribe') {
                formTools.serverErrorHandler(additionalSettings['form'])
            }

            if (data.status == 'recovered_account') {
                if (data.href) {
                    formTools.requestHomeClub(data.href);
                } else {
                    formTools.requestRegister();
                }
            }

            if (data.status == 'success') {
                if (data.href) {
                    formTools.requestHomeClub(data.href);
                } else {
                    formTools.requestRegister();
                }
            }
        });
    },

    passRestore: function (sendObject, additionalSettings) {
        $.post(requests.passRestore, sendObject, function (data) {
            if (data.status == 'not_fount_user') {
                formTools.errorRequest(additionalSettings['form'], data.status);
            }

            if (data.status == 'success') {
                formTools.requestRegister();
            }

            if (data.status) {
                formTools.loaderForm(additionalSettings['form'], 'stop');
            }
        });
    },

    editUserInfo: function (sendObject, additionalSettings) {
        $.post(requests.editUserInfo, sendObject, function (data) {
            if (data.status == 'success') {
                additionalSettings['form'].find('.form__input').each((i, el) => {
                    $(el).prop('disabled', true).attr('data-old-value', $(el).val())
                })
                $('.js_cabinet__info-submit').removeClass('active')
                $('.js_cabinet__info-button').removeClass('active')
            }

            if (data.status) {
                formTools.loaderForm(additionalSettings['form'], 'stop');
            }
        });
    },

    editUserPassword: function (sendObject, additionalSettings) {
        $.post(requests.editUserPassword, sendObject, function (data) {
            if (data.status == 'error_password' || data.status == 'error_repeat') {
                formTools.errorRequest(additionalSettings['form'], data.status);
            }

            if (data.status == 'error_reload_page') {
                formTools.reloadPage();
            }

            if (data.status == 'success') {
                clearForm(additionalSettings['form'])
                closePassEdit()
            }

            if (data.status) {
                formTools.loaderForm(additionalSettings['form'], 'stop');
            }
        });
    },

    paypal: function (sendObject) {
        delete sendObject.data.lang;

        $.post(requests.postDoOrder, {
            'lang': lang,
            'data': sendObject.data
        }, function (data) {
            if (data.status == 'paypal_error') {
                var result = confirm('An error occurred while trying to access PayPal, please try again. Click "OK" to reload the page.');

                if (result) {
                    location.reload();
                }
            }

            if (data.status == 'paypal') {
                window.location.href = data.link;
            }
        })
    }
};

$(document).ready(function () {
    $(document).on('input', '.form__input', function () {
        const wrapper = $(this).closest('.input_wrapper');
        formTools.clearErrors(wrapper);
    });

    $(document).on('change', 'input[name=policy_agree]', function () {
        const wrapper = $(this).closest('.input_wrapper');
        formTools.clearErrors(wrapper);
    });

    $(document).on('submit', '.js__valid_form', function (e) {
        e.preventDefault();

        const form = $(this);
        const requestName = form.data('form');
        const objectData = {
            'lang': lang,
        };

        const files = {};

        formTools.toggleButton('disabled', form);

        formTools.clearAllErrors();
        let error = 0;

        form.find('input, textarea').each(function () {
            const input = $(this);
            const name = input.attr('name');
            const wrapper = input.closest('.input_wrapper');
            let value = input.val().trim();

            if (wrapper.hasClass('required')) {
                if (value === '') {
                    formTools.showError(wrapper, '.js__main_error');
                    error++;
                } else if ((name === 'login' || name === 'email') && (!formTools.isValidEmail(value) || formTools.isNotClubEmail(value, requestName))) {
                    formTools.showError(wrapper, '.js__not_valid_email_error');
                    error++;
                } else if (name === 'phone') {
                    value = value.replace(/\D/g, '');
                    if (value === '') {
                        formTools.showError(wrapper, '.js__main_error');
                        error++;
                    }
                }
            }

            if (wrapper.hasClass('required_user')) {
                if (value !== '') {
                    if (!formTools.isValidPhone(value)) {
                        formTools.showError(wrapper, '.js_phone_not_valid');
                        error++;
                    } else {
                        value = value.replace(/\D/g, '');
                    }
                }
            }

            if (wrapper.hasClass('required_phone')) {
                if (value !== '') {
                    if (!formTools.isValidPhone(value)) {
                        formTools.showError(wrapper, '.js__not_valid_phone_error');
                        error++;
                    } else {
                        value = value.replace(/\D/g, '');
                    }
                } else {
                    formTools.showError(wrapper, '.js__main_error');
                    error++;
                }
            }

            if (name == 'policy_agree') {
                if (!input.is(':checked')) {
                    formTools.showError(wrapper, '.js__police_not_accept');
                    error++;
                }
            }

            if (input.hasClass('js__file_add_hidden')) {
                files[name] = value;
            } else {
                objectData[name] = value;
            }
        });

        objectData['files'] = files;

        let mini = requestName == 'usePromoCode' ? 'mini' : '';

        if (error === 0) {
            if (requestName != 'designRequests' && requestName != 'subscribe') {
                formTools.loaderForm(form, 'start', mini);
            }

            formTools.sortRequestForm(requestName, objectData, form);
        } else {
            formTools.toggleButton('unDisabled', form);
        }
    });
});


window.clearErrors = formTools.clearErrors;
window.clearForm = formTools.clearForm;